import { api } from './client';
import type { MigratedAuditLog } from '@/components/MigratedCrudHistory';

export interface KbasePerson {
  id: string;
  firstName: string;
  lastName: string;
}

export interface KbaseEntry {
  id: string;
  legacyId: number | null;
  problem: string;
  resolution: string;
  createdById: string | null;
  createdBy: KbasePerson | null;
  updatedById: string | null;
  updatedBy: KbasePerson | null;
  legacyUserlistId: number | null;
  legacyAuthorName: string | null;
  legacyUsername: string | null;
  legacySent: number | null;
  legacyCreatedAt: string | null;
  legacyLastChange: string | null;
  legacyLog: string | null;
  importedAt: string | null;
  needsVectorSync: boolean;
  createdAt: string;
  updatedAt: string;
}

export interface SaveKbaseEntryDto {
  problem: string;
  resolution: string;
}

export const kbaseApi = {
  getAll: async (search?: string): Promise<{ items: KbaseEntry[]; meta: { total: number } }> => {
    const { data } = await api.get('/kbase', {
      params: { search: search?.trim() || undefined },
    });
    return data;
  },

  getHistory: async (id: string): Promise<{ items: MigratedAuditLog[]; total: number }> => {
    const { data } = await api.get(`/kbase/${id}/history`);
    return data;
  },

  create: async (body: SaveKbaseEntryDto): Promise<KbaseEntry> => {
    const { data } = await api.post('/kbase', body);
    return data;
  },

  update: async (id: string, body: SaveKbaseEntryDto): Promise<KbaseEntry> => {
    const { data } = await api.patch(`/kbase/${id}`, body);
    return data;
  },
};
